import API from "./api"

export default function useAddAsset() {
  return async (data) => {
    return await API.post("/assets", data)
  }
}
